import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { HubScene } from './scenes/HubScene';
import { RoomScene } from './scenes/RoomScene';
import { mountHud } from './ui/hud';
import { createApp } from './app';
import { installAudio } from './audio';

export function startClient(gameRoot: HTMLElement, uiRoot: HTMLElement): Phaser.Game {
  const game = new Phaser.Game({
    type: Phaser.AUTO, parent: gameRoot, width: 1280, height: 720, backgroundColor: '#0d0a12',
    scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH },
    scene: [BootScene, HubScene, RoomScene], disableContextMenu: true,
  });
  createApp(game);
  installAudio(game, uiRoot);
  mountHud(uiRoot, game);
  return game;
}
